import { useSmsAutomationAccess } from '@features/sms/useSmsAutomationAccess';
import { SmsCreditDashboardCard } from '@features/sms/components/SmsCreditDashboardCard';
import { Stack } from '@mui/material';
import DashBoardCard from '@shared/components/DashBoardCard';
import { useDashboardPage } from './dashboard-page.hooks';

export const Dashboard = () => {
  const smsAutomationEnabled = useSmsAutomationAccess();
  const { config } = useDashboardPage();

  return (
    <Stack direction="column" rowGap={5}>
      {smsAutomationEnabled && <SmsCreditDashboardCard />}
      {config.map(card => (
        <DashBoardCard
          key={card.id}
          title={card.title}
          icon={card.icon}
          action={card.action}
          sx={card.sx}
        >
          {card.component}
        </DashBoardCard>
      ))}
    </Stack>
  );
};
